import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import ApplicationState from "@SupplyLand/Store/ApplicationState";
import { Draft } from "immer"; 

export type SupplyLandOnePageCheckoutState = Readonly<{
    isUpdatingCart: boolean;
    isBillingAddressTheSameAsShipping: boolean;
}>;

const initialState: SupplyLandOnePageCheckoutState = {
    isUpdatingCart: false,
    isBillingAddressTheSameAsShipping: false
};

const supplyLandOnePageCheckoutData = createTypedReducerWithImmer(initialState, {
    "SupplyLand/OnePageCheckout/SetIsUpdatingCart": (
        draft: Draft<SupplyLandOnePageCheckoutState>,
        action: { isUpdatingCart: boolean },
    ) => {
        draft.isUpdatingCart = action.isUpdatingCart;
    },
    "SupplyLand/OnePageCheckout/SetIsBillingAddressTheSameAsShipping": (
        draft: Draft<SupplyLandOnePageCheckoutState>,
        action: { isBillingAddressTheSameAsShipping: boolean },
    ) => {
        draft.isBillingAddressTheSameAsShipping = action.isBillingAddressTheSameAsShipping;
    },
});

export default (reducers as any).supplyLandOnePageCheckout = supplyLandOnePageCheckoutData;

export type CustomState = {
    supplyLandOnePageCheckout: SupplyLandOnePageCheckoutState;
} & ApplicationState;

type Reducers = {
    supplyLandOnePageCheckoutReducer: typeof supplyLandOnePageCheckoutData;
};

export type SupplyLandOnePageCheckoutActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
